<template>
  <!--单个商品组件（横向排序，一排三个，可换行）-->
  <div class="tk-grid-4">
    <tk-flex
      column
      center
      class="commodity-three-row"
      @click.native="$push({ path: '/commodity/productDetails', query: { id: commodity.objectId } })"
    >
      <div class="class-recommended-img">
        <tk-image class="class-recommended-image" :src="commodity.showPictures[0]" width="108" height="108"></tk-image>
      </div>
      <div class="three-row-bg" :style="{backgroundColor: bgColor}">
        <div class="font-14 m-t-2 class-card-black class-card-wrap van-ellipsis">{{commodity.productTitle}}</div>
        <div class="class-card-red m-t-2" v-if="commodity.oldPrice">
          <span class="font-10">￥</span>{{commodity.price}}
          <span class="font-12 m-l-5 class-card-decoration caption">
                    <span class="font-10">￥</span>{{commodity.oldPrice}}</span>
        </div>
        <div v-else>
          <div class="m-t-2 class-card-red"><span class="font-10">￥</span>{{commodity.price}}</div>
        </div>
      </div>
    </tk-flex>
  </div>
</template>

<script>
export default {
  props: {
    commodity: {
      type: Object
    },
    bgColor: {
      type: String,
      default: 'rgba(255, 255, 255, 0)'
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  .commodity-three-row {
    position: relative;
    border-radius: 5px;
    overflow: hidden;
    background: rgba(248,248,248,1);
  }
  .class-card-red { /*颜色及文本修饰*/
    color: rgba(250, 51, 51, 1);
  }
  .three-row-bg {
    width: 100%;
    padding-bottom: 4px;
    text-align: center;
  }
</style>
